import axios from 'axios';

export default function getBranchList({ payload }) {
    return new Promise((resolve, reject) => axios
        .get(`/analytic/admin/api/v1/managementportal/company/${payload.companyUuid}/branches`)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message))
    );
}
